import React, { useState } from 'react';
import { Card, Col, Row, Select, Form, Button, Space, Input } from 'antd';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { SelectRole } from 'components/input';

const { Option } = Select;

const formItemLayout = {
  wrapperCol: {
    xs: { span: 24 },
  },
};

const GET_SEARCH_DATA = gql`
  query getSearchData {
    faculties(state: ALL) {
      id
      abbreviation
      departments {
        id
        abbreviation
      }
    }
    roles(state: ALL) {
      id
      name
    }
  }
`;

const SearchUsers = ({ setSearch }) => {
  const { data, loading } = useQuery(GET_SEARCH_DATA);
  const [departments, setDepartments] = useState([]);
  const [form] = Form.useForm();

  const onFinish = (input) => {
    setSearch(input);
  };

  const onReset = () => {
    setSearch({
      netId: '',
      faculty: '',
      department: '',
      role: '',
    });
    form.resetFields();
    setDepartments([]);
  };

  const handleFacultyChange = (value) => {
    form.setFieldsValue({ department: undefined });
    value
      ? setDepartments(
          data.faculties
            .find(({ id }) => id === value)
            .departments.map(({ id, abbreviation }) => ({ id, abbreviation }))
        )
      : setDepartments([]);
  };

  return (
    <Card title="Search" loading={loading} bodyStyle={{ paddingBottom: '0' }}>
      {!loading && (
        <Form
          form={form}
          onFinish={onFinish}
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 17 }}
        >
          <Row gutter={24}>
            <Col xxl={6} xl={8} xs={24}>
              <Form.Item {...formItemLayout} name="netId" label="NetID">
                <Input
                  placeholder="Please enter"
                  style={{ width: '100%' }}
                  allowClear
                ></Input>
              </Form.Item>
            </Col>
            <Col xxl={6} xl={8} xs={24}>
              <Form.Item {...formItemLayout} name="faculty" label="Faculty">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.searchField
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Please select"
                  style={{ width: '100%' }}
                  allowClear
                  onChange={handleFacultyChange}
                >
                  {data.faculties.map(({ id, abbreviation }) => (
                    <Option value={id} key={id} searchField={abbreviation}>
                      {abbreviation}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={6} xl={8} xs={24}>
              <Form.Item
                {...formItemLayout}
                name="department"
                label="Department"
              >
                <Select
                  placeholder="Please select"
                  style={{ width: '100%' }}
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.searchField
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {departments.map(({ id, abbreviation }) => (
                    <Option value={id} key={id} searchField={abbreviation}>
                      {abbreviation}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={6} xl={8} xs={24}>
              <SelectRole placeholder="Please select" rules={[]} />
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: 'right' }}>
            <Space>
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
            </Space>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
};

SearchUsers.propTypes = {
  setSearch: PropTypes.func.isRequired,
};

export default SearchUsers;
